import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Text,
  SimpleGrid,
  Flex,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useToast,
  Avatar,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Tooltip as TooltipChakra } from "@chakra-ui/react";
import {
  PhoneIcon,
  EmailIcon,
  ChatIcon,
  InfoOutlineIcon,
} from "@chakra-ui/icons";
import { FaWhatsapp } from "react-icons/fa"; // For Meeting & WhatsApp
import { Icon } from "@chakra-ui/react";
import { SiGooglemeet } from "react-icons/si";
const statusOptions = ["Pending", "Completed", "Skipped"];
const priorityOptions = ["Low", "Medium", "High"];
const FollowUpTimeline = ({ followUps, leadId, lead }) => {
  // console.log("timeline",lead)
  const toast = useToast();
  const [localFollowUps, setLocalFollowUps] = useState(followUps);

  // Update local state if props change
  useEffect(() => {
    setLocalFollowUps(followUps);
  }, [followUps]);

  const updateFollowUpStatus = (leadId, followUpId, payload) =>
    axios.put(
      `https://develop-project-360.onrender.com/leads/${leadId}/follow-up/${followUpId}`,
      payload
    );

  const handleFollowUpFieldChange = async (
    leadId,
    followUpId,
    fieldName,
    newValue
  ) => {
    try {
      const updateData = { [fieldName]: newValue };
      await updateFollowUpStatus(leadId, followUpId, updateData);
      setLocalFollowUps((prev) =>
        prev.map((fu) =>
          fu._id === followUpId ? { ...fu, [fieldName]: newValue } : fu
        )
      );
      toast({
        title: `${
          fieldName.charAt(0).toUpperCase() + fieldName.slice(1)
        } Updated`,
        description: `Follow-up ${fieldName} changed to ${newValue}`,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
        variant: "subtle",
      });

      // Optional: Refresh data
    } catch (err) {
      toast({
        title: "Error",
        description:
          err.response?.data?.error ||
          `Failed to update follow-up ${fieldName}`,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
        variant: "subtle",
      });
    }
  };

  const getMethodIconAndAction = (method, fu) => {
    const phone = lead?.client_phone || "0000000000";
    const email = lead?.client_email || "example@example.com";
    // console.log(phone, email);
    switch (method) {
      case "Call":
        return {
          icon: <PhoneIcon />,
          action: () => window.open(`tel:${phone}`, "_blank"),
        };
      case "Email":
        return {
          icon: <EmailIcon />,
          action: () => window.open(`mailto:${email}`, "_blank"),
        };
      case "Message":
        return {
          icon: <ChatIcon />,
          action: () => window.open(`sms:${phone}`, "_blank"),
        };
      case "WhatsApp":
        return {
          icon: <Icon as={FaWhatsapp} />,
          action: () => window.open(`https://wa.me/${phone}`, "_blank"),
        };
      case "Meeting":
        return {
          icon: <Icon as={SiGooglemeet} />,
          action: () => window.open(`https://meet.google.com/new`, "_blank"),
        };
      default:
        return {
          icon: <InfoOutlineIcon />,
          action: () => alert("No action configured for this method"),
        };
    }
  };

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6} mt={6} w="100%">
      {localFollowUps.map((fu, i) => {
        const { icon, action } = getMethodIconAndAction(fu.method, fu);
        return (
          <Box
            key={i}
            p="6"
            borderRadius="xl"
            boxShadow="xl"
            bgGradient="linear(to-br, teal.400, green.300, teal.200)"
            color="white"
            textAlign={"start"}
          >
            <Flex justifyContent={"space-between"}>
              <Text fontWeight="bold" mb={2}>
                Note: {fu.note}
              </Text>
              <Menu>
                <MenuButton
                  as={Button}
                  rightIcon={<ChevronDownIcon />}
                  size="sm"
                  variant="outline"
                  borderColor="white"
                  rounded="full"
                  bgGradient="linear(to-r, green.500, teal.500)"
                  _hover={{ bgGradient: "linear(to-r, green.100, green.400)" }}
                >
                  {fu.status}
                </MenuButton>
                <MenuList bg="teal.300">
                  {statusOptions.map((status) => (
                    <MenuItem
                      key={status}
                      onClick={() =>
                        handleFollowUpFieldChange(
                          leadId,
                          fu._id,
                          "status",
                          status
                        )
                      }
                      fontWeight={fu.status === status ? "bold" : "normal"}
                      bg={fu.status === status ? "teal.400" : "teal.300"}
                      color="black"
                      _hover={{
                        bg: "teal.500",
                        color: "white",
                      }}
                    >
                      {status}
                    </MenuItem>
                  ))}
                </MenuList>
              </Menu>
            </Flex>
            <Text fontSize="sm" mt={2}>
              Next Follow Up
            </Text>
            <Text fontWeight="bold">
              {new Date(fu.next_followup).toLocaleDateString()}
            </Text>
            <Flex gap={3} mt={4}>
              <Button
                leftIcon={icon}
                variant="outline"
                borderColor="white"
                color="white"
                size="sm"
                rounded="full"
                onClick={action}
              >
                {fu.method}
              </Button>
              <Menu>
                <MenuButton
                  as={Button}
                  rightIcon={<ChevronDownIcon />}
                  size="sm"
                  variant="outline"
                  borderColor="white"
                  rounded="full"
                  bgGradient="linear(to-r, green.500, teal.500)"
                  _hover={{ bgGradient: "linear(to-r, green.100, green.400)" }}
                >
                  {fu.priority}
                </MenuButton>
                <MenuList bg="teal.300">
                  {priorityOptions.map((priority) => (
                    <MenuItem
                      key={priority}
                      onClick={() =>
                        handleFollowUpFieldChange(
                          leadId,
                          fu._id,
                          "priority",
                          priority
                        )
                      }
                      fontWeight={fu.priority === priority ? "bold" : "normal"}
                      bg={fu.priority === priority ? "teal.400" : "teal.300"}
                      color="black"
                      _hover={{
                        bg: "teal.500",
                        color: "white",
                      }}
                    >
                      {priority}
                    </MenuItem>
                  ))}
                </MenuList>
              </Menu>
            </Flex>
            <Flex
              justifyContent="center"
              alignItems="center"
              flexWrap="wrap"
              gap={2}
              mt={2}
            >
              {(() => {
                const allMentions = localFollowUps.flatMap(
                  (fu) => fu.mention || []
                );
                const firstFive = allMentions.slice(0, 5);
                const remaining = allMentions.slice(5);

                return (
                  <>
                    {firstFive.map((me, idx) => (
                      <TooltipChakra
                        key={idx}
                        label={me.sudo_name || "No sudo_name"}
                        placement="top"
                        hasArrow
                        bg="teal.500"
                        color="white"
                        fontSize="sm"
                      >
                        <Avatar
                          name={me.sudo_name || me.first_name}
                          src={
                            me.path
                              ? `https://develop-project-360.onrender.com/${me.path}`
                              : undefined
                          }
                          size="sm"
                          border="2px solid teal"
                        />
                      </TooltipChakra>
                    ))}

                    {remaining.length > 0 && (
                      <TooltipChakra
                        label={remaining
                          .map((m) => m.sudo_name || m.first_name || "Unknown")
                          .join(", ")}
                        placement="top"
                        hasArrow
                        bg="gray.600"
                        color="white"
                        fontSize="sm"
                      >
                        <Avatar
                          size="sm"
                          bg="gray.300"
                          color="black"
                          fontWeight="bold"
                          name={`+${remaining.length}`}
                        >
                          +{remaining.length}
                        </Avatar>
                      </TooltipChakra>
                    )}
                  </>
                );
              })()}
            </Flex>
          </Box>
        );
      })}
    </SimpleGrid>
  );
};

export default FollowUpTimeline;
